/* Vimshottari Dasha static lookup tables — no React, no imports needed */

export const NAKSHATRA_DASHA_LORD: Record<string, { lord: string; years: number }> = {
  ashwini: { lord: "Ketu", years: 7 },
  bharani: { lord: "Venus", years: 20 },
  krittika: { lord: "Sun", years: 6 },
  rohini: { lord: "Moon", years: 10 },
  mrigashira: { lord: "Mars", years: 7 },
  ardra: { lord: "Rahu", years: 18 },
  punarvasu: { lord: "Jupiter", years: 16 },
  pushya: { lord: "Saturn", years: 19 },
  ashlesha: { lord: "Mercury", years: 17 },
  magha: { lord: "Ketu", years: 7 },
  purva_phalguni: { lord: "Venus", years: 20 },
  uttara_phalguni: { lord: "Sun", years: 6 },
  hasta: { lord: "Moon", years: 10 },
  chitra: { lord: "Mars", years: 7 },
  swati: { lord: "Rahu", years: 18 },
  vishakha: { lord: "Jupiter", years: 16 },
  anuradha: { lord: "Saturn", years: 19 },
  jyeshtha: { lord: "Mercury", years: 17 },
  moola: { lord: "Ketu", years: 7 },
  purva_ashadha: { lord: "Venus", years: 20 },
  uttara_ashadha: { lord: "Sun", years: 6 },
  shravana: { lord: "Moon", years: 10 },
  dhanishta: { lord: "Mars", years: 7 },
  shatabhisha: { lord: "Rahu", years: 18 },
  purva_bhadrapada: { lord: "Jupiter", years: 16 },
  uttara_bhadrapada: { lord: "Saturn", years: 19 },
  revati: { lord: "Mercury", years: 17 },
};

export const DASHA_SEQUENCE = [
  { lord: "Ketu", years: 7 },
  { lord: "Venus", years: 20 },
  { lord: "Sun", years: 6 },
  { lord: "Moon", years: 10 },
  { lord: "Mars", years: 7 },
  { lord: "Rahu", years: 18 },
  { lord: "Jupiter", years: 16 },
  { lord: "Saturn", years: 19 },
  { lord: "Mercury", years: 17 },
];

export const DASHA_DETAILS: Record<string, { significations: string; nature: string }> = {
  Ketu: {
    significations: "Spirituality, detachment, past-life karma, mysticism, sudden changes",
    nature:
      "Ketu Mahadasha lasts 7 years. It brings spiritual awakening, detachment from material pursuits, and resolution of past-life karmic patterns. Can cause confusion in worldly matters but illuminates the spiritual path.",
  },
  Venus: {
    significations: "Love, marriage, luxury, arts, beauty, comfort, vehicles, relationships",
    nature:
      "Venus Mahadasha lasts 20 years. It is generally considered one of the most favorable periods, bringing material comforts, romantic fulfillment, artistic talents, and financial prosperity when Venus is well-placed.",
  },
  Sun: {
    significations: "Authority, career, father, government, health, self-confidence, leadership",
    nature:
      "Sun Mahadasha lasts 6 years. It brings focus on career advancement, authority, and recognition. The native gains confidence and leadership abilities. Government connections may strengthen.",
  },
  Moon: {
    significations: "Mind, emotions, mother, public life, travel, nurturing, intuition",
    nature:
      "Moon Mahadasha lasts 10 years. It enhances emotional sensitivity, public engagement, and connection with the mother. Mental peace and creative expression flourish when Moon is strong.",
  },
  Mars: {
    significations: "Courage, energy, property, siblings, surgery, military, technology",
    nature:
      "Mars Mahadasha lasts 7 years. It brings energy, ambition, and drive. Property acquisition, engineering pursuits, and physical vitality are highlighted. Can cause conflicts if Mars is afflicted.",
  },
  Rahu: {
    significations: "Foreign lands, technology, unconventional paths, obsession, sudden gains",
    nature:
      "Rahu Mahadasha lasts 18 years. It is a transformative period of worldly ambition, foreign connections, and unconventional achievements. Can bring sudden rises and falls, and involvement with technology or foreign cultures.",
  },
  Jupiter: {
    significations: "Wisdom, children, education, dharma, wealth, expansion, teaching",
    nature:
      "Jupiter Mahadasha lasts 16 years. Generally the most auspicious period, bringing wisdom, spiritual growth, children, education, and expansion in all life areas. Financial and career growth through righteous means.",
  },
  Saturn: {
    significations: "Discipline, karma, longevity, hard work, service, delays, justice",
    nature:
      "Saturn Mahadasha lasts 19 years. It teaches discipline, patience, and the value of hard work. Results come through sustained effort. Can bring career stability and authority earned through competence.",
  },
  Mercury: {
    significations: "Intelligence, communication, business, writing, analysis, trade, education",
    nature:
      "Mercury Mahadasha lasts 17 years. It enhances intellectual abilities, communication skills, business acumen, and analytical thinking. Favorable for writers, traders, educators, and those in technology.",
  },
};

export function formatNakshatra(raw: string): string {
  return raw.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
